<template>
    <div>
        <ly-form-item :label="all.lable" v-for="(all, indext) in picList" :key="indext">

            {{ all.remark }}
            <imgList :data="all.fileList"></imgList>
        </ly-form-item>
    </div>
</template>
<script>
export default {
    props: ['data'],
    data() {
        return {
            picList: [],
            item: {

                filePathList: [{
                    fileList: [],
                    reamrk: ''
                }
                ]
            }
        }
    },
    methods: {
        load() {
            //console.log(this.data);
            var t = this.data.filePathList;
           // console.log(t);

            //console.log(this.data);
            if (!this.utils.isEmpty(t)) {
                t = t.sort(function (a, b) {
                    return a.sort - b.sort;
                });
                this.picList = t;
            }
            //console.log('文件列表', t)
            // 
        }
    },
    mounted() {
        this.load();
    }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/diaodu/jincheng/filePathList.vue